<template>
  <div>
    <div class="userNavigation">
      <ul class="nav navbar-nav">
        <li class="nav-item" v-if="isActivityPage && isUserLoggedIn">
          <router-link class="nav-link" :to="searchLocation"><i class="fa fa-search searchIcon" aria-hidden="true"></i> {{t('Last Search...')}}</router-link>
        </li>
        <li v-if="isUserLoggedIn && userType !== 'promoter'" class="nav-item myBookingsMenuLink"><router-link class="nav-link" :to="`/${language}/bookings`">{{t('My Bookings')}} <span class="badge badge-light" v-if="bookings.length > 0">{{bookings.length}}</span></router-link></li>
        <li v-if="totalUnpaidCount > 0 && isUserLoggedIn" class="nav-item paymentsMenuLink">
          <router-link class="nav-link" :to="`/${language}/payment`">{{t('Payments')}}<span class="badge badge-danger">{{totalUnpaidCount}}</span></router-link>
        </li>
        <li class="nav-item CalendarAndBookingsMenuLink" v-if="isActivityPage"><i class="fa fa-calendar calendarIcon" aria-hidden="true"></i><a class="nav-link" href="#" @click="toggleCalendarOnTop()">{{t('Calendar and Bookings')}}</a></li>
      </ul>
        <div class="demoMessage">This site exists for demonstration purposes only. All information contained has been randomly generated.</div>
      <!--ContactUsLinks class="contactUs"/-->
    </div>
    <div class="warnings text-xs-center" v-if="totalUnpaidCount > 0 && $route.name !== 'User Payment'">
      {{t('You have unpaid bookings')}}. <router-link :to="`/${language}/payment`">{{t('Go to payments')}}</router-link>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ContactUsLinks from './ContactUsLinks';

const $ = window.jQuery;
export default {
  name: 'UserNavigation',
  components: {
    ContactUsLinks,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      bookings: state => state.bookingPublic.data,
      userType: state => state.user.data.type,
      search: state => state.search,
    }),
    isUserLoggedIn() {
      if (typeof this.$store.state.userDeprecated.data.username !== 'undefined') {
        if (this.$store.state.userDeprecated.data.username !== '') {
          return true;
        }
      }
      return false;
    },
    searchLocation: {
      get() {
        if (typeof this.search !== 'undefined') {
          return `/${this.language}/search?startDate=${this.search.startDate}&endDate=${this.search.endDate}&location=${this.search.location.value}`; // eslint-disable-line
        }
        return false;
      },
    },
    isActivityPage() {
      if (typeof this.$route.matched[1] !== 'undefined') {
        if (this.$route.matched[1].name === 'User Activity') {
          return true;
        }
      }
      return false;
    },

    ...mapGetters({
      totalUnpaidCount: 'bookingPublic/totalUnpaidCount',
    }),
  },
  methods: {
    ...mapActions({
      toggleCalendarOnTop: 'activityUI/toggleCalendarOnTop',
      loadSearch: 'search/loadFromStorage',
    }),
    placeTawk() {
      setTimeout(() => {
        if (window.innerWidth < 768) {
          if (document.querySelector('.userNavigation').clientHeight !== null) {
            const menuHeight = document.querySelector('.userNavigation').clientHeight;
            const chatDistance = `${menuHeight + 20}px`;
            document.querySelectorAll('[title="chat widget"]').forEach(el => Object.assign(el.style, { bottom: chatDistance }));
          }
        } else {
          document.querySelectorAll('[title="chat widget"]').forEach(el => Object.assign(el.style, { bottom: '20px' }));
        }
      }, 0);
    },
  },
  mounted() {
    this.loadSearch();
    // 768px
    const self = this;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.onLoad = () => {
      self.placeTawk();
    };
    $(window).resize(() => {
      self.placeTawk();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4";
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
/* 1.  ALL SCREENS*/
.badge {
  position: absolute;
  display: block;
  right: 5px;
  top: 5px;
  border-radius: 50%;
  background: white;
  font-size: 10px;
  width: 16px;
  height: 16px;
  color: $brand-primary;
  line-height: 16px;
}
.badge-danger {
  color: #bb2222;
  font-weight: bold;
}

.userNavigation {
  position: fixed;
  display: flex;
flex-wrap: wrap;
  width: 100%;
  bottom: 0;
  background-color: lighten(#00695C, 5%);
}
.navbar-nav .nav-item {
  display: flex;
  flex-direction: row;
  line-height: 40px;
  margin-left: 0;
  text-align: center;
  .nav-link {
  width: 100%;
}
}
.contactUs {
  margin-top: 12px;
  margin-bottom: 6px;
  margin-left: 15px;
  padding-right: 30px;
}
ul li:not(:first-child) {
  border-left: 1px solid white;
}
ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  li {
    flex: 1 1 auto;
    align-self: center;
    text-align: center;
    position: relative;
    border: 1px solid white;
    padding-left: 30px;
    margin-right: -1px;
    margin-bottom: -1px;
    .fa {
      position: absolute;
      left: 3vw;
      top: 18px;
      color: white;
    }
    a {
      color: white;
    }
    .text-muted {
      color: black !important;
    }
  }
  .myBookingsMenuLink, .paymentsMenuLink {
    padding-left: 0;
  }
}
.warnings {
  background: #e19b2d;
  color: white;
  padding-top: 3px;
  padding-bottom: 3px;
  a {
    color: white;
    text-decoration: underline;
  }
}

  .navbar-nav {
    width: 100%;
    .nav-item {
      padding-left: 15px;
    }
  }
/* Small Screen 544px */
@media only screen and (min-width: map-get($grid-breakpoints, sm)) {

}

/* Small Devices, Tablets 768px */
@media only screen and (min-width: map-get($grid-breakpoints, md)) {
  .navbar-nav {
    width: auto;
  }

  .badge {
    top: 0;
    right: -16px;
  }
  .userNavigation {
    display: flex;
    justify-content: space-between;
    position: static;
    padding-left: calc(6%);
    padding-right: calc(1rem + 6%);
  }
  .myBookingsMenuLink {
    display: table-cell;
  }

  .CalendarAndBookingsMenuLink {
    display: none !important;
  }
  .navbar-nav .nav-item {
    float: left;
    margin-top: .5rem;
    margin-bottom: 0.5rem;
  }

  ul li:not(:first-child) {
    border-left: 0 none;
  }
  ul {
    display: flex;
    overflow: hidden;
    padding-left: 30px;
    li {
      padding-left: 0;
      border: 0;
      margin-right: 30px;
      display: inline-block;
      width: auto;
      a {
        line-height: 21px;
      }
      .fa {
        position: static;
      }
    }
  }
}

/* Medium Devices, Desktops */
@media only screen and (min-width: map-get($grid-breakpoints, lg)) {

}

/* Large Devices, Wide Screens  1200px */
@media only screen and (min-width: map-get($grid-breakpoints, xl)) {

}

.demoMessage {
 color: white;
 text-align: center;
 padding-top: 8px;
 padding-bottom: 8px;
 width: 100%;
 font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// UserNavigation.vue?5600f344